module.exports = __webpack_public_path__ + "static/media/food-and-restaurant1.5986047f.png";